import React from "react";
import { ErrorMessage, Field, FieldArray, useFormikContext } from "formik";
import {
  DatePicker,
  FieldDropSide,
  FieldInput,
  FieldInputDecimal,
  FieldInputSSN,
  SearchableList,
  FieldInputNumberAsString,
} from "../../../components";
import { get, isEmpty } from "lodash";
import {
  getFormattedSsn,
  OPTIONS_DATA_MAPPER,
  required,
  toOptionValuesFromMapper,
  usDateFormat,
  FORM_PLACEHOLDERS,
  getFormattedPhone,
  getFormattedZip,
} from "../../../utils";
import {
  getPayrollFrequencies,
  getEmploymentStatusList,
} from "../../../services";
import { manageCompanyStore } from "../../../contexts";
import { getStates, getStatesList, getCountriesList } from "../../../services";
import payrollFrequency from "../../../mocks/payrollFrequency.json";
import OtherInformationFields from "../../Employee/EmployeeInformationContainer/OtherInformation";
import CensusFormEmployeeClassification from "./CensusFormEmployeeClassification";
import { useEffect, useState } from "react";
import { useDeepEffect, useRequest } from "../../../abstracts";
import moment from "moment";

const CensusFormDetails = ({
  fields,
  data,
  fileType,
  awaitingFunding,
  isStartDate,
  setIsLoading,
  isEndDate,
  setErrorList,
  states,
  countries,
  frequencyList,
  setErrors,
  errorList,
  setHoursErrorId,
  censusWarnings,
  isWarningSlide,
}) => {
  const formProps = useFormikContext();
  const {
    values,
    handleChange,
    setFieldValue,
    setFieldError,
    setFieldTouched,
    errors,
  } = formProps;
  // useDeepEffect(() => {
  //   var tempError = {};
  //   data?.errorMessages.forEach((_) => {
  //     if (_.errorType == 1 || _.errorType == 2) {
  //       switch (_.controlName) {
  //         case "ytdHours":
  //           // setFieldError("hoursDetails[0].ytdHours", _.messageDescCode);
  //           // tempError.hoursDetails[0].ytdHours = _.messageDescCode;
  //           tempError["hoursDetails"] = [
  //             {
  //               ytdHours: _.messageDescCode,
  //             },
  //           ];
  //           break;

  //         case "payPeriodHours":
  //           // setFieldError("hoursDetails[0].payPeriodHours", _.messageDescCode);
  //           tempError["hoursDetails"] = [
  //             {
  //               payPeriodHours: _.messageDescCode,
  //             },
  //           ];
  //           break;
  //         case "payPeriodGrossCompensation":
  //           // setFieldError("compensations[0].payPeriodAmount", _.messageDescCode);
  //           // tempError.compensations[0].payPeriodAmount = _.messageDescCode;
  //           tempError["compensations"] = [
  //             {
  //               payPeriodAmount: _.messageDescCode,
  //             },
  //             ...get(tempError, "compensations", []),
  //           ];
  //           break;
  //         case "payPeriodPlanCompensation":
  //           // setFieldError("compensations[1].payPeriodAmount", _.messageDescCode);
  //           // tempError.compensations[1].payPeriodAmount = _.messageDescCode;
  //           tempError["compensations"] = [
  //             ...get(tempError, "compensations", []),
  //             {
  //               payPeriodAmount: _.messageDescCode,
  //             },
  //           ];
  //           break;
  //         case "ytdGrossCompensation":
  //           // setFieldError("compensations[0].ytdAmount", _.messageDescCode);
  //           // tempError.compensations[0].ytdAmount = _.messageDescCode;
  //           tempError["compensations"] = [
  //             {
  //               ytdAmount: _.messageDescCode,
  //             },
  //             ...get(tempError, "compensations", []),
  //           ];
  //           break;
  //         case "ytdPlanCompensation":
  //           // setFieldError("compensations[1].ytdAmount", _.messageDescCode);
  //           // tempError.compensations[1].ytdAmount = _.messageDescCode;
  //           tempError["compensations"] = [
  //             ...get(tempError, "compensations", []),
  //             {
  //               ytdAmount: _.messageDescCode,
  //             },
  //           ];
  //           break;
  //         default:
  //           // setFieldError(_.controlName, _.messageDescCode);
  //           tempError[_.controlName] = _.messageDescCode;
  //           break;
  //       }
  //     }
  //   });
  //   setErrorList(tempError);
  // }, [data]);
  const onDaySelected = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };
  const calculateAge = (birthDate) => {
    var a = moment();
    var b = moment(new Date(birthDate), "MM-YYYY");
    var age = moment.duration(a.diff(b));
    return age.years() <= 1 && age.months() <= 1
      ? age.years() + " year " + age.months() + " month"
      : age.years() <= 1
      ? age.years() + " year " + age.months() + " months"
      : age.months() <= 1
      ? age.years() + " years " + age.months() + " month"
      : age.years() + " years " + age.months() + " months";
  };
  // useEffect(()=>{
  //   Object.Keys(errors).ForEach(_=> {
  //     setFieldTouched(errors[_]);
  //   })
  // },[])
  const handleHoursChnage = (e, num) => {
    const current = e.target.value;
    if (num === 1) {
      const prev = values?.hoursDetails?.[0]?.payPeriodHours;
      const ytdHrs = values?.hoursDetails?.[0]?.ytdHours + (current - prev);
      setFieldValue("hoursDetails[0].ytdHours", ytdHrs);
      handleChange(e);
    } else {
      const prev = values?.hoursDetails?.[0]?.ytdHours;
      const payPeriodHrs =
        values?.hoursDetails?.[0]?.payPeriodHours + (current - prev);
      setFieldValue("hoursDetails[0].payPeriodHours", payPeriodHrs);
      handleChange(e);
    }
  };
  const errorSSN =
    !isEmpty(censusWarnings) &&
    censusWarnings?.filter(
      (_) => _.controlName == "uniquePersonalIdentification" && _.errorType == 2
    );

  const { response: employmentStatusList } = useRequest({
    method: getEmploymentStatusList,
    payload: get(values, "companyId", 0),
    defaultResponse: [],
  });
  const masterEmploymentStatusId = employmentStatusList.find(
    ({ id }) => id === values[fields.employmentStatusId]
  )
    ? employmentStatusList.find(
        ({ id }) => id === values[fields.employmentStatusId]
      ).employmentStatus
    : 0;
  return (
    <div className="d-flex column-scroll" style={{ height: "70%" }}>
      <div className="w-100">
        <div className="plan-sub-heading">Personal Details</div>
        <Field
          name={fields.firstName}
          label={"First name"}
          type="text"
          autoComplete="off"
          value={values[fields.firstName]}
          onChange={handleChange}
          component={FieldInput}
          disabled={awaitingFunding || isWarningSlide}
          isCensusPayrollError={true}
          isRequired
        />

        <Field
          name={fields.middleName}
          label={"Middle name/initial"}
          type="text"
          autoComplete="off"
          value={values[fields.middleName]}
          onChange={handleChange}
          component={FieldInput}
          isCensusPayrollError={true}
          disabled={awaitingFunding || isWarningSlide}
        />
        <Field
          name={fields.lastName}
          label={"Last name"}
          type="text"
          autoComplete="off"
          value={values[fields.lastName]}
          onChange={handleChange}
          component={FieldInput}
          disabled={awaitingFunding || isWarningSlide}
          isCensusPayrollError={true}
          isRequired
        />
        <Field
          label="Gender"
          size="md"
          placeholder="Select Gender"
          name={fields.gender}
          direction="right"
          disabled={awaitingFunding || isWarningSlide}
          options={toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.GENDER)}
          popupContent={
            <SearchableList
              label="Select Gender"
              options={toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.GENDER)}
              onSelect={(value) => setFieldValue(fields.gender, value)}
              name={fields.gender}
              selectedValue={values[fields.gender]}
            />
          }
          isCensusPayrollError={true}
          component={FieldDropSide}
        />

        <Field
          label="Marital Status"
          size="md"
          placeholder="Select Marital Status"
          disabled={awaitingFunding || isWarningSlide}
          name={fields.maritalStatus}
          value={values[fields.maritalStatus]}
          direction="right"
          options={toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.MARITAL_STATUS)}
          popupContent={
            <SearchableList
              label="Select Marital Status"
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.MARITAL_STATUS
              )}
              onSelect={(value) => setFieldValue(fields.maritalStatus, value)}
              selectedValue={values[fields.maritalStatus]}
            />
          }
          isCensusPayrollError={true}
          component={FieldDropSide}
        />
        <div className="d-flex">
          <Field
            label="Date of Birth"
            size="md"
            disabled={awaitingFunding || isWarningSlide}
            name={fields.birthDate}
            value={usDateFormat(values[fields.birthDate])}
            isDatePicker
            onClear={() => onDaySelected(fields.birthDate, null)}
            popupContent={
              <DatePicker
                onDayClick={(value) => onDaySelected(fields.birthDate, value)}
                value={usDateFormat(values[fields.birthDate])}
              />
            }
            isCensusPayrollError={true}
            component={FieldDropSide}
            isRequired
          />
          {values.birthDate === undefined ||
          values.birthDate === null ||
          values.birthDate > new Date() ? (
            ""
          ) : (
            <div
              className="plan-sub-heading mt-20 ml-4"
              style={{ alignSelf: "flex-end" }}
            >
              {calculateAge(values.birthDate)}
            </div>
          )}
        </div>
        <Field
          size="md"
          name={fields.uniquePersonalIdentification}
          label={"Social Security Number"}
          disabled={true}
          type="text"
          autoComplete="off"
          value={getFormattedSsn(values[fields.uniquePersonalIdentification])}
          //onChange={handleChange}
          onChange={(e) => {
            setFieldValue(
              fields.uniquePersonalIdentification,
              getFormattedSsn(e.target.value)
            );
          }}
          isCensusPayrollError={true}
          component={FieldInputSSN}
          placeholder={FORM_PLACEHOLDERS.ssn}
          disableField={true}
          maxLength="11"
          isRequired
          errorId={!isEmpty(errorSSN) && errorSSN[0].id}
          setErrorId={setHoursErrorId}
          hide={!isEmpty(errorSSN) && errorSSN[0].errorType == 2}
        />
        <div className="plan-sub-heading">Contact Information</div>
        <Field
          label="Email"
          name={fields.primaryEmailAddress}
          disabled={awaitingFunding || isWarningSlide}
          type="text"
          value={values[fields.primaryEmailAddress]}
          onChange={handleChange}
          autoComplete="nope"
          isCensusPayrollError={true}
          component={FieldInput}
        />
        <Field
          size="md"
          name={fields.mobilePhoneNumber}
          label={"Primary Phone Number"}
          disabled={awaitingFunding || isWarningSlide}
          type="text"
          autoComplete="off"
          value={getFormattedPhone(values[fields.mobilePhoneNumber])}
          //onChange={handleChange}
          onChange={(e) => {
            setFieldValue(
              fields.mobilePhoneNumber,
              getFormattedPhone(e.target.value)
            );
          }}
          component={FieldInput}
          isCensusPayrollError={true}
          placeholder={FORM_PLACEHOLDERS.phone}
          maxLength="12"
        />
        <div className="plan-sub-heading">Address</div>
        {/* <Field
          size="md"
          name={fields.address}
          label={"Address Name"}
          type="text"
          autoComplete="off"
          value={values[fields.address]}
          onChange={handleChange}
          component={FieldInput}
          isCensusPayrollError={true}
        /> */}
        <Field
          size="md"
          name={fields.address1}
          label={"Address 1"}
          disabled={awaitingFunding || isWarningSlide}
          type="text"
          autoComplete="off"
          value={values[fields.address1]}
          onChange={handleChange}
          component={FieldInput}
          isCensusPayrollError={true}
          isRequired
        />
        <Field
          size="md"
          name={fields.address2}
          label={"Address 2"}
          disabled={awaitingFunding || isWarningSlide}
          type="text"
          autoComplete="off"
          value={values[fields.address2]}
          onChange={handleChange}
          component={FieldInput}
          isCensusPayrollError={true}
        />
        <Field
          size="md"
          name={fields.address3}
          disabled={awaitingFunding || isWarningSlide}
          label={"Address 3"}
          type="text"
          autoComplete="off"
          value={values[fields.address3]}
          onChange={handleChange}
          component={FieldInput}
          isCensusPayrollError={true}
        />
        <Field
          label="City"
          name={fields.city}
          type="text"
          disabled={awaitingFunding || isWarningSlide}
          value={values[fields.city]}
          onChange={handleChange}
          autoComplete="nope"
          component={FieldInput}
          isCensusPayrollError={true}
          isRequired
        />
        <Field
          size="md"
          isRequired
          name={fields.countryId}
          value={values[fields.countryId]}
          label="Country"
          disabled={awaitingFunding || isWarningSlide}
          options={
            countries &&
            countries.map((country, index) => ({
              label: country.code,
              value: country.id,
            }))
          }
          popupContent={
            <SearchableList
              label="Select Country"
              options={
                countries &&
                countries.map((country, index) => ({
                  label: country.code,
                  value: country.id,
                }))
              }
              onSelect={(value, label) => {
                setFieldValue(fields.country, label);
                setFieldValue(fields.countryId, value);
                setFieldValue(fields.countryCode, label);
                setFieldValue(fields.zipCode, null);
                value == 1 &&
                  setFieldValue(fields.foreignCountry, null) &&
                  setFieldValue(fields.foreignState, null);
                value == 2 &&
                  setFieldValue(fields.state, null) &&
                  setFieldValue(fields.stateId, null);
                // getStatesList(fields.countryId)
                //   .then((response) => {
                //     setStateList(response);
                //   })
                //   .catch((error) => {
                //     //Handle error
                //   });
              }}
              value={values[fields.countryId]}
              selectedValue={values[fields.countryId]}
            />
          }
          isCensusPayrollError={true}
          component={FieldDropSide}
        />

        {values[fields.countryId] == 1 && (
          <>
            <Field
              size="md"
              name={fields.stateId}
              label="State"
              disabled={awaitingFunding || isWarningSlide}
              options={
                states &&
                states.map((state, index) => ({
                  label: state.stateDescription,
                  value: state.id,
                }))
              }
              value={values[fields.stateId]}
              isRequired
              popupContent={
                <SearchableList
                  options={
                    states &&
                    states.map((state, index) => ({
                      label: state.stateDescription,
                      value: state.id,
                    }))
                  }
                  onSelect={(value) => {
                    setFieldValue(fields.stateId, value);
                    setFieldValue(
                      fields.state,
                      states.filter((x) => x.id == value)[0].stateCode
                    );
                  }}
                  height="250px"
                  selectedValue={values[fields.stateId]}
                  value={values[fields.stateId]}
                />
              }
              isCensusPayrollError={true}
              component={FieldDropSide}
            />
            <Field
              size="smd"
              name={fields.zipCode}
              label={"Zip Code"}
              disabled={awaitingFunding || isWarningSlide}
              type="text"
              autoComplete="off"
              isCensusPayrollError={true}
              //onChange={handleChange}
              onChange={(e) => {
                setFieldValue(fields.zipCode, getFormattedZip(e.target.value));
              }}
              onlyNumbersAndHyphen
              component={FieldInputNumberAsString}
              value={getFormattedZip(values[fields.zipCode])}
              placeholder={FORM_PLACEHOLDERS.zip}
              maxLength="10"
              isRequired
            />
          </>
        )}

        {values[fields.countryId] == 2 && (
          <>
            <Field
              size="md"
              isRequired
              name={fields.foreignCountry}
              label={"Foreign Country"}
              disabled={awaitingFunding || isWarningSlide}
              type="text"
              autoComplete="off"
              value={values[fields.foreignCountry]}
              onChange={handleChange}
              component={FieldInput}
              isCensusPayrollError={true}
            />
            <Field
              size="md"
              isRequired
              name={fields.foreignState}
              label={"Foreign State"}
              disabled={awaitingFunding || isWarningSlide}
              type="text"
              autoComplete="off"
              value={values[fields.foreignState]}
              onChange={handleChange}
              component={FieldInput}
              isCensusPayrollError={true}
            />
            <Field
              size="md"
              isRequired
              name={fields.zipCode}
              label={"Foreign Zip Code"}
              disabled={awaitingFunding || isWarningSlide}
              type="text"
              autoComplete="off"
              onChange={handleChange}
              component={FieldInput}
              isCensusPayrollError={true}
              value={values[fields.zipCode]}
            />
          </>
        )}

        <div className="plan-sub-heading">Profile Information</div>
        <Field
          size="md"
          name={fields.companyName}
          value={values[fields.companyName]}
          label="Company Name"
          disabled={true}
          onChange={handleChange}
          component={FieldInput}
          isCensusPayrollError={true}
          isRequired
        />
        <Field
          size="md"
          name={fields.employeeNumber}
          label={"Employee ID"}
          disabled={awaitingFunding || isWarningSlide}
          noLabelTransform
          type="text"
          autoComplete="off"
          value={values[fields.employeeNumber]}
          onChange={handleChange}
          component={FieldInput}
          isCensusPayrollError={true}
        />

        <Field
          size="md"
          name={fields.payrollFrequencyId}
          label="Payroll Frequency"
          disabled={awaitingFunding || isWarningSlide}
          direction="right"
          isRequired
          options={
            frequencyList &&
            frequencyList.map((frequency, index) => ({
              label: frequency.name,
              value: frequency.id,
            }))
            //  [{label:"monthly",value:257}]
          }
          popupContent={
            <SearchableList
              label="Select Payroll Frequency"
              options={
                frequencyList &&
                frequencyList.map((frequency, index) => ({
                  label: frequency.name,
                  value: frequency.id,
                }))
              }
              name={fields.payrollFrequencyId}
              onSelect={(value) => {
                setFieldValue(fields.payrollFrequencyId, value);
                setFieldValue(
                  fields.payrollFrequency,
                  frequencyList.filter((x) => x.id == value)[0].name
                );
              }}
              selectedValue={values[fields.payrollFrequencyId]}
            />
          }
          isCensusPayrollError={true}
          component={FieldDropSide}
        />
        <Field
          size="md"
          isRequired
          name={fields.employmentStatus}
          label="Employment Status"
          disabled={awaitingFunding || isWarningSlide}
          popupContent={
            <SearchableList
              label="Select Employment Status"
              options={
                employmentStatusList &&
                employmentStatusList.map((status, index) => ({
                  label: status.employmentStatusName,
                  value: status.id,
                }))
              }
              onSelect={(value) => {
                setFieldValue(
                  fields.employmentStatus,
                  employmentStatusList.find((x) => x.id === value)
                    .employmentStatusName
                );
                setFieldValue(fields.employmentStatusId, value);
                let _ = employmentStatusList.find(({ id }) => id === value);
                if (!isStartDate && ![4, 5, 9].includes(_.employmentStatus)) {
                  setFieldValue(fields.leaveStartDate, null);
                }
                if (!isEndDate && ![4, 5, 9].includes(_.employmentStatus)) {
                  setFieldValue(fields.leaveEndDate, null);
                }
              }}
              selectedValue={values[fields.employmentStatusId]}
              value={values[fields.employmentStatusId]}
            />
          }
          isCensusPayrollError={true}
          component={FieldDropSide}
        />
        <Field
          label="Leave Start Date"
          isRequired
          size="md"
          name={fields.leaveStartDate}
          value={usDateFormat(values[fields.leaveStartDate])}
          isDatePicker
          onClear={() => onDaySelected(fields.leaveStartDate, null)}
          popupContent={
            <DatePicker
              onDayClick={(value) =>
                onDaySelected(fields.leaveStartDate, value)
              }
              value={usDateFormat(values[fields.leaveStartDate])}
            />
          }
          isCensusPayrollError={true}
          component={FieldDropSide}
          disabled={![4, 5, 9].includes(masterEmploymentStatusId)}
        />
        <Field
          label="Leave End Date"
          size="md"
          name={fields.leaveEndDate}
          value={usDateFormat(values[fields.leaveEndDate])}
          isDatePicker
          onClear={() => onDaySelected(fields.leaveEndDate, null)}
          popupContent={
            <DatePicker
              onDayClick={(value) => onDaySelected(fields.leaveEndDate, value)}
              value={usDateFormat(values[fields.leaveEndDate])}
            />
          }
          isCensusPayrollError={true}
          component={FieldDropSide}
          disabled={![4, 5, 9].includes(masterEmploymentStatusId)}
        />
        <Field
          label="Hire Date"
          size="md"
          disabled={awaitingFunding || isWarningSlide}
          name={fields.hireDate}
          value={usDateFormat(values[fields.hireDate])}
          isDatePicker
          onClear={() => onDaySelected(fields.hireDate, null)}
          isRequired
          popupContent={
            <DatePicker
              onDayClick={(value) => onDaySelected(fields.hireDate, value)}
              value={usDateFormat(values[fields.hireDate])}
            />
          }
          isCensusPayrollError={true}
          component={FieldDropSide}
        />
        <Field
          label="Most Recent Term Date"
          size="md"
          disabled={awaitingFunding || isWarningSlide}
          name={fields.mostRecentTermDate}
          value={usDateFormat(values[fields.mostRecentTermDate])}
          isDatePicker
          onClear={() => onDaySelected(fields.mostRecentTermDate, null)}
          popupContent={
            <DatePicker
              onDayClick={(value) =>
                onDaySelected(fields.mostRecentTermDate, value)
              }
              value={usDateFormat(values[fields.mostRecentTermDate])}
            />
          }
          isCensusPayrollError={true}
          component={FieldDropSide}
        />
        <Field
          label="Most Recent Rehire Date"
          size="md"
          disabled={awaitingFunding || isWarningSlide}
          name={fields.reHireDate}
          value={usDateFormat(values[fields.reHireDate])}
          isDatePicker
          onClear={() => onDaySelected(fields.reHireDate, null)}
          popupContent={
            <DatePicker
              onDayClick={(value) => onDaySelected(fields.reHireDate, value)}
              value={usDateFormat(values[fields.reHireDate])}
            />
          }
          isCensusPayrollError={true}
          component={FieldDropSide}
        />
        {fileType == 1 && (
          <FieldArray name={fields.hoursDetails}>
            {() => {
              const hoursDetails = get(values, "hoursDetails", []);
              return (
                <>
                  <Field
                    label="Pay Date"
                    size="md"
                    disabled={true}
                    name={"hoursDetails[0].payDate"}
                    value={usDateFormat(hoursDetails[0]?.payDate)}
                    isDatePicker
                    isRequired
                    isCensusPayrollError={true}
                    component={FieldDropSide}
                  />
                  <Field
                    size="xs"
                    name={"hoursDetails[0].payPeriodHours"}
                    autoComplete="off"
                    label="Hours"
                    noLabelTransform={true}
                    onChange={(e) => {
                      handleHoursChnage(e, 1);
                    }}
                    disabled={
                      values[fields.modeOfHours] != 1 || awaitingFunding
                    }
                    max={9999}
                    isCensusPayrollError={true}
                    component={FieldInputDecimal}
                  />
                  <Field
                    size="xs"
                    name={"hoursDetails[0].ytdHours"}
                    label="YTD Hours"
                    noLabelTransform={true}
                    autoComplete="off"
                    onChange={(e) => {
                      handleHoursChnage(e, 2);
                    }}
                    disabled={
                      values[fields.modeOfHours] == 1 || awaitingFunding
                    }
                    max={9999}
                    isCensusPayrollError={true}
                    component={FieldInputDecimal}
                  />
                </>
              );
            }}
          </FieldArray>
        )}
        <CensusFormEmployeeClassification
          id={values.companyId}
          awaitingFunding={awaitingFunding}
          isWarningSlide={isWarningSlide}
        />
        <OtherInformationFields
          {...formProps}
          fields={fields}
          awaitingFunding={awaitingFunding}
          isWarningSlide={isWarningSlide}
        />
      </div>
    </div>
  );
};

export default CensusFormDetails;
